import { FC } from "react";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { GlobalConfigDefinition } from "@app/core/globalConfig";
import { useConfig } from "@dit/ui-configurations/configurations";
import { OnlyChildrenProps } from "@app/core/children";

const reactPlugin = new ReactPlugin();
const AppInsightsLoader: FC<OnlyChildrenProps> = ({ children }) => {
    const config = useConfig<InsightsDefinition, GlobalConfigDefinition>(c => c.insights, {
        azure: { enabled: false, connectionString: "not_set", instrumentationKey: "not_set" },
    });
    const appInsights = new ApplicationInsights({
        config: {
            instrumentationKey: config?.azure?.instrumentationKey,
            enableAutoRouteTracking: true,
            extensions: [reactPlugin],
            connectionString: config?.azure?.connectionString,
            disableTelemetry: !!!config?.azure?.enabled,
            disableAjaxTracking: false,
            disableFetchTracking: false,
        },
    });
    appInsights.loadAppInsights();

    return <>{children}</>;
};

export { reactPlugin, AppInsightsLoader };
